var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Error 404")]),_c('div',[_c('router-link',{attrs:{"to":{ path: `/dashboard` }}},[_vm._v("Go to Home")])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"img/404.png","alt":""}})])
}]

export { render, staticRenderFns }